import {
    FETCH_ADMIN_PLANS_LOADING,
    FETCH_ADMIN_PLANS_SUCCESS,
    FETCH_ADMIN_PLANS_FAILED,
  } from "../types";

  const initialState = {
    data: [],
    loading: false,
    error: null,
  };

  export const planReducer = (state = initialState, action: any) => {
    switch (action.type) {
      case FETCH_ADMIN_PLANS_LOADING:
        return { ...state, loading: true, error: null };
      case FETCH_ADMIN_PLANS_SUCCESS:
        return { ...state, loading: false, data: action.payload };
      case FETCH_ADMIN_PLANS_FAILED:
        return { ...state, loading: false, error: action.payload };
      default:
        return state;
    }
  };
  